/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createDetailFieldHook } from '../../core/factories/createDetailFieldHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetOutcomeChartRow } from '../openapi-types.gen.js';
import { type useGetOutcomeChartArgs, useGetOutcomeChartSpec, useGetOutcomeChartRealtime } from '../specs/outcomes.spec.gen.js';

export type { GetOutcomeChartRow } from '../openapi-types.gen.js';
export type { useGetOutcomeChartArgs } from '../specs/outcomes.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): outcomeMint, start, end, timeframe.
 */
const _useGetOutcomeChart = createHook(useGetOutcomeChartSpec, useGetOutcomeChartRealtime);
export const useGetOutcomeChart = _useGetOutcomeChart as (args: useGetOutcomeChartArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetOutcomeChart>;


/**
 * Per-field subscription hook for the \`useGetOutcomeChart\` cache entry.
 * Pass the SAME args as the parent hook (same queryKey → same cache). Returns the named field's value; only the call site
 * re-renders when that field changes (TanStack tracked-properties +
 * per-component `select`).
 *
 *     function Title({ pubkey }) {
 *       const value = useGetOutcomeChartField({ pubkey }, 'title');
 *       return <h3>{value}</h3>;
 *     }
 */
export const useGetOutcomeChartField = createDetailFieldHook(useGetOutcomeChartSpec);

/**
 * Hover/intent prefetch companion for `useGetOutcomeChart`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetOutcomeChart();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetOutcomeChart = createPrefetchHook(useGetOutcomeChartSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetOutcomeChartArgs>;
